/**
 * @licstart The following is the entire license notice for the
 * JavaScript code in this page
 *
 * Copyright 2024 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @licend The above is the entire license notice for the
 * JavaScript code in this page
 */

/******/ // The require scope
/******/ var __webpack_require__ = {};
/******/ 
/************************************************************************/
/******/ /* webpack/runtime/define property getters */
/******/ (() => {
/******/ 	// define getter functions for harmony exports
/******/ 	__webpack_require__.d = (exports, definition) => {
/******/ 		for(var key in definition) {
/******/ 			if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 				Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 			}
/******/ 		}
/******/ 	};
/******/ })();
/******/ 
/******/ /* webpack/runtime/hasOwnProperty shorthand */
/******/ (() => {
/******/ 	__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ })();
/******/ 
/************************************************************************/
var __webpack_exports__ = globalThis.pdfjsTypes = {};

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  AnnotationEditorControlsType: () => (/* reexport */ AnnotationEditorControlsType),
  AnnotationEditorParamsType: () => (/* reexport */ AnnotationEditorParamsType),
  AnnotationEditorType: () => (/* reexport */ AnnotationEditorType)
});

;// ./src/shared/types.js
const AnnotationEditorType = {
  DISABLE: -1,
  NONE: 0,
  FREETEXT: 3,
  HIGHLIGHT: 9,
  STAMP: 13,
  INK: 15,
  TEXT_CONTENT: 17,
  ERASER: 18,
  SHAPE: 19,
  ANY: 20,
  CUSTOM_SIGNATURE: 22,
  PARAGRAPH: 23,
  SIGNATURE: 101
};
const AnnotationEditorParamsType = {
  RESIZE: 1,
  CREATE: 2,
  FREETEXT_SIZE: 11,
  FREETEXT_COLOR: 12,
  FREETEXT_OPACITY: 13,
  INK_COLOR: 22,
  INK_THICKNESS: 23,
  INK_OPACITY: 24,
  HIGHLIGHT_COLOR: 31,
  HIGHLIGHT_DEFAULT_COLOR: 32,
  HIGHLIGHT_THICKNESS: 33,
  HIGHLIGHT_FREE: 34,
  HIGHLIGHT_SHOW_ALL: 35,
  DRAW_STEP: 41,
  TEXT_CONTENT_COLOR: 50,
  TEXT_CONTENT_OPACITY: 51,
  TEXT_CONTENT_SIZE: 52,
  ERASER_COLOR: 61,
  SHAPE_TYPE: 70,
  SHAPE_COLOR: 73,
  SHAPE_THICKNESS: 74,
  OPACITY: 62,
  SHAPE_FILL_COLOR: 76,
  SHAPE_TRANSPARENT_COLOR: 77,
  SHAPE_TRANSPARENT_FILL: 78,
  TEXT_ALIGN: 90,
  TEXT_FONT: 91,
  TEXT_BOLD: 92,
  TEXT_ITALIC: 93,
  TEXT_UNDERLINE: 94,
  TEXT_STRIKETHROUGH: 95,
  TEXT_LIST: 96,
  TEXT_BACKGROUND_COLOR: 97,
  TEXT_SIZE_PREVIEW: 98,
  TEXT_VARIANTS: 99
};
const AnnotationEditorControlsType = {
  PAGE_CENTERING: 1
};

;// ./src/types.js


var __webpack_exports__AnnotationEditorControlsType = __webpack_exports__.AnnotationEditorControlsType;
var __webpack_exports__AnnotationEditorParamsType = __webpack_exports__.AnnotationEditorParamsType;
var __webpack_exports__AnnotationEditorType = __webpack_exports__.AnnotationEditorType;
export { __webpack_exports__AnnotationEditorControlsType as AnnotationEditorControlsType, __webpack_exports__AnnotationEditorParamsType as AnnotationEditorParamsType, __webpack_exports__AnnotationEditorType as AnnotationEditorType };

//# sourceMappingURL=types.mjs.map